import AddIcon from "@mui/icons-material/Add";
import { Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={6}>
		<Button design="primary" endIcon={<AddIcon />} />
		<Button design="primary" endIcon={<AddIcon />}>Primary</Button>
		<Button design="secondary" endIcon={<AddIcon />}>Secondary</Button>
		<Button design="outline" endIcon={<AddIcon />}>Outline</Button>
		<Button design="link" endIcon={<AddIcon />}>Link</Button>
		<Button design="linkSubtle" endIcon={<AddIcon />}>Link Subtle</Button>
	</CssColumnGrid>
);